import firebase from "@firebase/app";
import '@firebase/messaging'

export default class {
    static sendNotification(notificationSubscriptionIds, title, body) {
        const url = `https://us-central1-xerpa-40c1c.cloudfunctions.net/webapi/v1/sendNotification`

        const notification = {
            notificationSubscriptionIds: notificationSubscriptionIds,
            title: title,
            body: body
        }

        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(notification)
        }).then(res => {
            if (res.ok) {
                return res.json();
            } else {
                throw Error("Could not send notification");
            }
        }).catch(err => {
            throw Error(err);
        });
    }

    static subscribe(store) {
        function registerToken(store, messaging) {
            messaging.getToken().then((currentToken) => {
                if (currentToken) {
                    store.dispatch("setNotificationSubscriptionId", currentToken);
                } else {
                    window.console.log('No Instance ID token available. Request permission to generate one.');
                }
            }).catch(err => {
                window.console.log(err);
            });
        }

        const messaging = firebase.messaging();
        messaging.usePublicVapidKey("BN0HQmNBgiPnROjHVZBelKpTkMptGF8sbKAqEdjxLU5MMZwZMub6jLPNYgCPPBCTtRR9vPUt3tsdagNloN3gOA8");

        registerToken(store, messaging);

        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                registerToken(store, messaging);
            }
        });

        messaging.onTokenRefresh(() => {
            registerToken(store, messaging);
        });
    }
}